<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.number"
          :label="$t('global.number')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.externalLot"
          :label="$t('profile.material.externallot')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialProductVersionSelectItems"
          v-model="item.materialProductVersion"
          :items="materialProductVersionSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('profile.material.productversion')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'MaterialProductLotFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.materialProductVersionGetSelectItems();
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    ...mapFields('materialproductversion', {
      materialProductVersionSelectItems: 'selectItems',
    }),
  },
  methods: {
    ...mapActions({
      materialProductVersionGetSelectItems: 'materialproductversion/fetchSelectItems',
    })
  }
};
</script>
